<!--
option:
imgW:图片宽
imgH:图片高
slidesPerView:每页显示图片数，默认 3
-->
<template>
  <div class="v-swiper-box" :style="{ height: propOpthion.imgH }" @click.stop="a">
    <swiper class="swiper" :options="swiperOption">
      <swiper-slide v-for="(item, index) in option.list" :key="index">
        <template v-if="item">
          <slot name="swiper-slide" :slideData="item">
            <div class="img-box" :style="{height: propOpthion.imgH, width: propOpthion.imgW }" :class="{'swiper-active': option.active == index}" @click.stop="cb('swiper', { item, index })">
              <img class="icon-vedio" v-if="option.type && option.type[index] == 'video'" :src="iconVideo" />
              <img v-lazy="item.split && $funcs.compressImage(item.split(',')[0], Number(propOpthion.imgW), Number(propOpthion.imgH))" @error="imgImg" :style="{height: propOpthion.imgH}" class="lazy-img-fadein" />
            </div>
          </slot>
        </template>
      </swiper-slide>
      <div class="swiper-button-prev" slot="button-prev" v-if="isShowSwiperBtn && showBtn"></div>
      <div class="swiper-button-next" slot="button-next" v-if="isShowSwiperBtn && showBtn"></div>
    </swiper>
  </div>
</template>
<script>
import def from '@/assets/def.jpg'
import iconVideo from '@/assets/images/icon_vedio.png'

export default {
  props: {
    option: {
      type: [Object, String],
      default: () => ''
    },
    showBtn: {
      type: [Boolean],
      default: true
    }
  },
  components: {},
  data() {
    return {
      iconVideo,
      swiperOption: {
        iconVideo,
        roundLengths: true,
        updateOnImagesReady: true,
        slidesPerView: this.option.slidesPerView ? this.option.slidesPerView : 3,
        // 图片间距
        spaceBetween: this.option.spaceBetween ? this.option.spaceBetween : 15,
        freeMode: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        direction: this.option.direction ? 'vertical' : 'horizontal',
        //swiper 高度
        height: this.option.height ? this.option.height : 'auto'
      },
      propOpthion: this.option ? this.option : { imgW: '', imgH: '' }
    }
  },
  computed: {
    isShowSwiperBtn() {
      // eslint-disable-next-line no-unused-vars
      let isT = false
      if (this.option.list) {
        isT = this.option.list.length > this.swiperOption.slidesPerView
      }
      return true
    }
  },
  methods: {
    cb(type, param) {
      this.$emit('callback', { type, data: param })
      return true
    },
    imgImg(e) {
      e.target.src = def
    },
    a() {}
  }
}
</script>
<style lang="stylus" scoped>
.icon-vedio {
  position: relative
  display: block;
  position: absolute;
  left: 50%;
  top: 50%;
  width: 62px;
  height: 62px;
  margin-left: -31px;
  margin-top: -31px;
}

.swiper-button-prev:after, .swiper-button-next:after{
  font-size:30px;
  line-height :1.5;
}

.swiper-button-prev, .swiper-button-next{
  color:$color-main;
}

.img-box img:not(.icon-vedio) {
  object-fit: contain;
  background: $color-black-10;
  cursor pointer
}
.swiper-active{
  position relative

  &:before{
    content: '';
    position: absolute;
    left: 0;
    top: 0
    width: 100%;
    height: 100%;
    background-color: $color-black-25;
    z-index: 10;
  }
}
</style>
